import React, { useCallback, useEffect } from 'react';

import queryString from 'query-string';
import { DefaultPopover, Input, Separator } from 'twyne-new.ui';

import { useQueryparams } from 'utils';
import history from 'utils/history';

import { usePivotData } from './Context';
import { PermanentLinkButton } from '@/components/reports/header';

export default function PermanentLink({ value, onChange }) {
  const { onChagePivotData, ...pivotby } = usePivotData()
  const query = useQueryparams(true)

  useEffect(() => {
    if (query && query.configure) {
      try {
        const state = JSON.parse(atob(query.configure))
        onChange(state)
      } catch (e) {}
    }
  }, [query])

  const dumpState = useCallback(() => {
    return btoa(JSON.stringify({ ...value, pivotby }))
  }, [value, pivotby])

  return <>
    <DefaultPopover trigger={<PermanentLinkButton />}>
      Permanent Link
      <Separator className='m-0 my-2' />
      <URLView id="permanent-link-input" dumpState={dumpState} />
    </DefaultPopover>
  </>
}

const URLView = ({ id, dumpState }) => {
  useEffect(() => {
    const input = document.querySelector(`#${id}`)

    const a = document.createElement('a')
    a.href = history.createHref({
      ...history.location,
      search: queryString.stringify({ configure: dumpState() })
    })

    input.value = a.href

    input.select()
    document.execCommand('copy')
  })

  return <>
    <Input id={id} readOnly />
    <small className='twy-text-base'>Copied!</small>
  </>
}
